import { useEffect, useRef, useState } from 'react';

type Props = {
    src: string;
    maxHeight?: number;
};

export const IframeRenderer = ({ src, maxHeight = 2500 }: Props) => {
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const [ height, setHeight ] = useState(100);

    useEffect(() => {
        const handler = (event: MessageEvent) => {
            if (event.data?.type !== 'iframe-height') {
                return;
            }

            if (event.source !== iframeRef.current?.contentWindow) {
                return;
            }

            setHeight(Math.min(event.data.height, maxHeight));
        };

        window.addEventListener('message', handler);

        return () => window.removeEventListener('message', handler);
    }, [ maxHeight ]);

    return (
        <iframe
            title={`${src}-iframe-renderer`}
            ref={iframeRef}
            src={src}
            style={{
                width: '100%',
                height,
                maxHeight,
                border: 0,
            }}
        />
    );
};

export default IframeRenderer;
